import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CartProduct } from '@app/shared/models/product';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import { UpdateCart, MoveToWishList, CheckInventoryInStock } from '../../models/cart';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { GetCartItemsInterface } from '@app/feature/end-user/services/cart/GetCartItems.interface';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(private httpClient: HttpClient) { }

  /** Temporarily adds item to cart */
  AddItemToCart(cartModel: CartProduct) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post(environment.baseUrl + AppConstant.AddItemToCart, cartModel, { headers: headers_1 });
  }
  /** Temporarily adds warehouse item to cart */
  AddWareItemToCart(cartModel: CartProduct) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post(environment.baseUrl + AppConstant.AddItemToCart, cartModel, { headers: headers_1 });
  }

  /** Fetches cart items on the basis of userid and storeid*/
  GetCartItems(userid: any, storeid: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.get<APIResponse<GetCartItemsInterface[]>>(environment.baseUrl + AppConstant.GetCartItems + '?UserId=' + userid +
      '&StoreId=' + storeid, { headers: headers_1 });
  }

  /** Update/Delete cart
  * OperationType -> 1 - Update ; 2 - Delete;
   */
  UpdateCart(updateCart: UpdateCart) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post(environment.baseUrl + AppConstant.UpdateCart, updateCart, { headers: headers_1 });
  }

  /** Update/Delete cart
 * OperationType -> 1 - Update ; 2 - Delete;
  */
  MoveToWishList(moveToWishList: MoveToWishList) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post(environment.baseUrl + AppConstant.MoveItemsToWishList, moveToWishList, { headers: headers_1 });
  }

  /** Make API call to Cart*/
  CheckCartPrice(userId: any, storeId: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.get<APIResponse<boolean>>(environment.baseUrl + AppConstant.CheckCartPrice + '?StoreId=' + storeId +
      '&UserId=' + userId, { headers: headers_1 });
  }

  /** Check avaiable quantity for  cart**/
  CheckAvailableInventoryForWareHouseProduct(CheckInventoryInStockModel: CheckInventoryInStock[]) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post(environment.baseUrl + AppConstant.CheckInventoryForWareHouseProduct, { CheckInventoryInStockModel }, { headers: headers_1 });
  }
  
  GetDiliveryCost(payload: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.httpClient.post<APIResponse<boolean>>(environment.baseUrl + AppConstant.GetShippingCost,payload, { headers: headers_1 });
  }
  GetThirdPartyShipping(storeId: number) {
    return this.httpClient.get<APIResponse<boolean>>(environment.baseUrl + AppConstant.GetThirdPartyShipping + '?StoreId=' + storeId);
  }
}
